import LoginForm from 'profile/login/forms/LoginForm';

const ReturningCustomer = () => (
  <div className="c7-account-login--returning-customer">
    <h4>Returning Customer</h4>
    <LoginForm
      redirectLink="/reservation/checkout/checkout"
      forgotPasswordLink="/reservation/checkout/forgot-password"
      magicLink="/reservation/checkout/magic-link"
    />
  </div>
);

export default ReturningCustomer;
